module.exports = __webpack_public_path__ + "static/media/cancelled-seats.9fa254ea.svg";